module.exports = __webpack_public_path__ + "static/img/rank_51.9bd5f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_51.png
// module id = cZdA
// module chunks = 0